import { logError } from '@util/logError';

/**
 * Reports a failed dashboard read with the route and operation that failed.
 *
 * Why not `logError(err, undefined, context)`: logError's third parameter is a
 * component stack, and for the Google Cloud Error Reporting path it REPLACES
 * the error's real stack (`ctx.stack = componentStack`). GCP groups by stack,
 * so passing route context there would collapse every failure on a route into
 * one group keyed by a constant sentence and throw away where it happened.
 *
 * Instead the context goes in the message and the original stack is carried
 * over, which keeps grouping intact in both Sentry and GCP.
 */
export function reportDashboardError(context: string, err: unknown) {
  const original = err instanceof Error ? err : new Error(String(err));
  const wrapped = new Error(`${context}: ${original.message}`);
  wrapped.name = original.name;
  if (original.stack) wrapped.stack = original.stack;
  logError(wrapped);
}
